<aside
  [attr.aria-expanded]="!leftSidebarClosed"
  class="axis-left-sidebar axis-sidebar-fixed size-small"
  [class.axis-sidebar-close]="leftSidebarClosed"
  role="complementary"
  aria-label="Steps"
  [attr.tabindex]="!leftSidebarClosed ? -1 : 0"
>
  <div class="axis-sidebar-btn _hidden-xl-up">
    <button
      (click)="leftSidebarClosed = !leftSidebarClosed"
      [attr.aria-label]="'Left sidebar ' + (leftSidebarClosed ? 'closed' : 'opened')"
      [class.axis-sidebar-btn-close]="leftSidebarClosed"
      axis-button
      class="kind-icon"
    >
      <axis-icon
        icon="chevron_right"
        font="custom"
      ></axis-icon>
    </button>
  </div>

  <div class="axis-sidebar-content">
    <div class="axis-sidebar-body size-small">
      <div class="axis-progress-step direction-vertical counter-none kind-secondary">
        <ul class="axis-progress-indicator">
          @for (item of currentSteps; let i = $index; track i) {
            <li
              class="axis-progress-item"
              [class.active]="item.active"
              [class.completed]="item.completed"
            >
              <div>{{ item.heading }}</div>

              @if (item.substeps?.length) {
                <ul class="axis-progress-indicator nested">
                  @for (substep of item.substeps; let j = $index; track j) {
                    <li
                      class="axis-progress-item {{ substep.active ? 'active' : '' }} {{ substep.completed ? '_cursor-pointer' : '' }}"
                      [class.active]="substep.active"
                      [class.completed]="substep.completed"
                      (click)="!substep.disabled && step_clickHandler(substep)"
                    >
                      <div>{{ substep.heading }}</div>
                    </li>
                  }
                </ul>
              }
            </li>
          }
        </ul>
      </div>

      @if (this.headerSharedService.moreDetails) {
        <div class="_text-xlarge">More Details</div>
        <ul class="axis-sidebar-nav-list">
          @if (!router.url.match("uimui-non-digital")) {
            @if (isUIUMEnabled) {
              <li class="axis-sidebar-nav-item">
                <div class="axis-sidebar-nav">
                  <div class="axis-sidebar-nav-left">
                    <axis-icon
                      icon="file"
                      font="custom"
                    ></axis-icon>
                  </div>
                  <div class="axis-sidebar-nav-body">Review Unsigned UM/UIM State Forms</div>

                  <div class="axis-sidebar-nav-right">
                    <button
                      axis-button
                      class="kind-icon"
                      (click)="reviewUMUIMStateForms()"
                      aria-label="Open Modal"
                    >
                      <axis-icon
                        icon="chevron_right"
                        font="custom"
                      ></axis-icon>
                    </button>
                  </div>
                </div>
              </li>
            }
          }
          @if (!router.url.match("pip-non-digital")) {
            @if (isPIPEnabled) {
              <li class="axis-sidebar-nav-item">
                <div class="axis-sidebar-nav">
                  <div class="axis-sidebar-nav-left">
                    <axis-icon
                      icon="file"
                      font="custom"
                    ></axis-icon>
                  </div>
                  <div class="axis-sidebar-nav-body">Review Unsigned PIP State Forms</div>
                  <div class="axis-sidebar-nav-right">
                    <button
                      axis-button
                      class="kind-icon"
                      (click)="reviewPIPStateForms()"
                      aria-label="Open Modal"
                    >
                      <axis-icon
                        icon="chevron_right"
                        font="custom"
                      ></axis-icon>
                    </button>
                  </div>
                </div>
              </li>
            }
          }
        </ul>
      }
    </div>
  </div>
</aside>

<app-modal-pip-review-form #modalPIPReviewForm></app-modal-pip-review-form>
<app-modal-uimui-review-form #modalUIMUIReviewForm></app-modal-uimui-review-form>
